import React, { Component } from 'react';
import {
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import { generate } from 'shortid';
// components
import FieldGroup from '../FieldGroup/FieldGroup';
// stores
import UserStore from '../../stores/UserStore';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.ids = { email: generate() };
    this.state = {
      email: "",
      response: ""
    };
  }

  render() {
    return (
      <div className="Login-container">
        <form onSubmit={this.handleOnSubmit}>
          <FieldGroup
            focus
            id={this.ids.email}
            name="email"
            label="E-mail"
            type="email"
            value={this.state.email}
            placeholder="bob@example.com"
            help="We'll send you a link to reset your password."
            onChange={this.handleChange} />
          <Row>
            <Col xs={5}>
              <Button type="submit" bsStyle="primary">Send reset link</Button>
            </Col>
            <Col xs={7}>
              {this.renderResponse()}
            </Col>
          </Row>
        </form>
      </div>
    );
  }

  renderResponse = () => {
    if (!this.state.response) {
      return;
    }

    const {
      state,
      message
    } = this.state.response;
    const className = `text-${state === "error" ? "danger" : "success"}`;
    return (<div style={{"fontSize": "9pt"}} className={className}>{message}</div>);
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState({ email: e.target.value });
    return false;
  }

  handleOnSubmit = (e) => {
    e.preventDefault();
    const onReset = this.props.onReset || (() => {});
    this.setState({ response: null });
    UserStore.forgotPassword(this.state.email)
    .then(() => {
      this.setState({ response: { state: "success", message: "Sent! Please check your e-mail" }});
      onReset(true);
    })
    .catch(error => {
      console.error(error);
      this.setState({ response: { state: "error", message: error.message }});
      onReset(false);
    });
    return false;
  }
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/components/Auth/ForgotPassword.js